import requests from '@/utils/requests';

/**
 * 更新日志列表
 * @param {*} data
 */
export function changelogList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/about/changelog/list',
    method: 'post',
    data
  });
}

/**
 * 添加更新日志
 * @param {*} data
 */
export function changelogAdd (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/about/changelog/add',
    method: 'post',
    data
  });
}
/**
 * 修改更新日志
 * @param {*} data
 */
export function changelogModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/about/changelog/modify',
    method: 'post',
    data
  });
}

/**
 * 更新日志详情
 * @param {*} data
 */
export function changelogDetail (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/about/changelog/detail',
    method: 'post',
    data
  });
}

/**
 * 删除更新日志
 * @param {*} data
 */
export function changelogDelete (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/about/changelog/delete',
    method: 'post',
    data
  });
}

/**
 * 推送更新日志
 * @param {*} data
 */
export function changelogPush (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/about/changelog/push',
    method: 'post',
    data
  });
}

/**
 * 更新用户查看更新日志状态
 * @param {*} data
 */
export function changelogRead (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/about/changelog/read',
    method: 'post',
    data
  });
}
